<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="light-container-popup-basic">
	<div class="light-container__header">{{ appStrings.PASTE_MODES_INFO_POPUP_HEADER }}</div>
	<div class="light-container__text-block paste-modes-info-plain-text paste-modes-info-popup-layout">
		<b>{{ appStrings.PASTE_MODE_EXACT_COPY }}</b
		><br />
		{{ appStrings.PASTE_MODES_INFO_TEXT_AFTER_EXACT_COPY }}<br />
		<br />
		<b>{{ appStrings.PASTE_MODE_TEMPLATE_CURRENT }}</b
		><br />
		{{ appStrings.PASTE_MODES_INFO_TEXT_AFTER_TEMPLATE_CURRENT }}<br />
		<br />
		<b>{{ appStrings.PASTE_MODE_TEMPLATE_ORIGINAL }}</b
		><br />
		{{ appStrings.PASTE_MODES_INFO_TEXT_AFTER_TEMPLATE_ORIGINAL }}<br />
		<br />
		{{ appStrings.PASTE_MODES_INFO_TEXT_AFTER_TEMPLATES }}
	</div>
	<div class="light-container-popup__footer space-children-h">
		<button
			(click)="writeOutput(); complete()"
			class="legacy-button btn--blue"
			automationId="pasteModeInfoConfirmBtn"
		>
			{{ appStrings.PASTE_MODES_INFO_CONFIRM_BUTTON }}
		</button>
	</div>
</div>
